module.exports = __webpack_public_path__ + "img/6.81cf9b19.jpg";